import { Directive, forwardRef, Input, TemplateRef } from '@angular/core';

export interface CollapsibleRowOption {
	id: string;
	isCollapsed: boolean;
}

export abstract class CollapsibleRow {
	public appCollapsibleRow: CollapsibleRowOption = {
		id: '',
		isCollapsed: false,
	};
	public tmpRef: TemplateRef<unknown> | unknown;
}

@Directive({
	selector: '[appCollapsibleRow]',
	providers: [
		{
			provide: CollapsibleRow,
			useExisting: forwardRef(() => CollapsibleRowDirective),
		},
	],
})
export class CollapsibleRowDirective {
	@Input() public appCollapsibleRow: CollapsibleRowOption = {
		id: '',
		isCollapsed: false,
	};

	constructor(public tmpRef: TemplateRef<unknown>) {}
}
